/** @format */

import React, {useEffect, useState} from "react";
import {HomeTabsParams} from "../../navigation/AppStack/HomeTabParams";
import {WalletStackRoute} from "../../navigation/AppStack/routes";
import {Text} from "react-native-paper";
import {Keyboard, Platform, StyleSheet, TouchableWithoutFeedback, View} from "react-native";
import {AppTheme, useTheme} from "../../theme/colors";
import {Button} from "../../components";
import PageContainer from "../../components/PageContainer";
import {ButtonType} from "../../theme";
import {NavigationProp, RouteProp, useNavigation} from "@react-navigation/native";
import CustomTextInput, {CustomTextInputChangeEvent,} from "../../components/CustomTextInput";
import Dropdown from "../../components/Dropdown";
import * as DocumentPicker from "expo-document-picker";
import {API} from "../../utils/API";
import useAuth from "../../contexts/Auth/useAuth";
import {generatePassportFile} from "../../services/NetworkManager";
import {Storage} from "../../utils/Storage";
import CustomAlert from "../../components/CoustmizeAlertmsg";
import {UploadFileScreenRoute, WalletScreenRoute} from "../../navigation/WalletStack/routes";
import {WalletStackParams} from "../../navigation/WalletStack/WalletStack";
import {getSession} from "../../utils/cognitoAuth"; // Import getSession for fetching the token

export interface UploadFileScreenInterface {
    selected_file_name: string;
    file_title: string;
    file_folder: string;
    file_password: string;
}

const defaultUploadFileScreenFormValues: UploadFileScreenInterface = {
    selected_file_name: "",
    file_title: "",
    file_folder: "",
    file_password: "",
};

interface UploadFileScreenProps {
    route: RouteProp<WalletStackParams, typeof UploadFileScreenRoute>;
}

const UploadFileScreen = ({route}: UploadFileScreenProps) => {
    const {image} = route?.params || {}
    const [formData, setFormData] = useState<UploadFileScreenInterface>(
      defaultUploadFileScreenFormValues
    );
    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [isAlertVisible, setAlertVisibility] = useState<boolean>(false);
    const [Message, setMessage] = useState<string>("");
    const [errors, setErrors] = useState<Partial<UploadFileScreenInterface>>(
      {}
    );
    const navigation = useNavigation<NavigationProp<HomeTabsParams>>();
    const {user} = useAuth();
    const theme = useTheme();
    const uploadFileScreenStyles = getShareScreenStyles(theme);

    useEffect(() => {
        if (image && 'contentUri' in image && 'fileName' in image && 'mimeType' in image) {
            if (Platform.OS != 'ios') {
                setSelectedFile({
                    uri: image.contentUri,
                    name: image.fileName,
                    type: image.mimeType,
                } as unknown as File)
                setFormData((prev) => ({
                    ...prev,
                    selected_file_name: image.fileName
                }))
            } else {
                console.log("ios:" + image.filePath);
                setSelectedFile({
                    uri: image.filePath,
                    name: image.fileName,
                    type: image.mimeType,
                } as unknown as File)
                setFormData((prev) => ({
                    ...prev,
                    selected_file_name: image.fileName
                }))

            }
        }
    }, [image])

    const onClickCancelButton = () => {
        resetFields()
        navigation.navigate(WalletStackRoute, {
            screen: WalletScreenRoute,
            params: undefined
        });
    };


    const renderFileFoldersSelectOptions = () => {
        return (
          <View style={{gap: 10}}>
              <Text style={{fontSize: 14, fontWeight: "300"}}>Folder</Text>
              <View style={{paddingHorizontal: 10, gap: 15}}>
                  <Dropdown
                    defaultValue={formData.file_folder}
                    onSelect={(value) => {
                        setFormData((prevState) => {
                            return {
                                ...prevState,
                                file_folder: value,
                            };
                        });
                        return value;
                    }}
                    label=""
                    simple
                    data={[
                        "OneSpace",
                        "DSA or Access to work",
                        "Reports and Assessments",
                        "NHS notes",
                        "References",
                        "Other",
                    ]}
                  />
              </View>
          </View>
        );
    };
    const onChangeTextField = (event: CustomTextInputChangeEvent) => {
        const { name, value } = event;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,  // ✅ updates formData.file_title
        }));
    };

    const selectFileHandler = async () => {
        try {
            const result = await DocumentPicker.getDocumentAsync({
                copyToCacheDirectory: true,
            });
            if (
              result.canceled === false &&
              result.assets &&
              result.assets.length > 0
            ) {
                if (Platform.OS === "web") {
                    setSelectedFile(result.assets[0]?.file || null);
                    setFormData((prev) => ({
                        ...prev,
                        selected_file_name: result.assets[0].name ?? "",
                    }));
                } else if (Platform.OS === "ios" || Platform.OS === "android") {
                    const fileUri = result.assets[0]?.uri;
                    if (fileUri) {
                        setSelectedFile({
                            uri: fileUri,
                            name: result.assets[0]?.name,
                            type: result.assets[0]?.mimeType
                        } as unknown as File);
                        setFormData((prev) => ({
                            ...prev,
                            selected_file_name: result.assets[0].name ?? "",
                        }));
                        setErrors((prevErrors) => ({
                            ...prevErrors,
                            selected_file_name: "",
                        }));
                    }
                }
            } else {
                throw new Error("Document Picking Canceled");
            }
        } catch (err) {
            console.log("Error occurred:", err);
        }
    };

    const validateForm = () => {
        const newErrors: Partial<UploadFileScreenInterface> = {};

        if (!selectedFile) {
            newErrors.selected_file_name = "Please select a file.";
        }
        if (!formData.file_title.trim()) {
            newErrors.file_title = "Please enter a title.";
        }
        if (!formData.file_folder) {
            newErrors.file_folder = "Please select a folder.";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const resetFields = () => {
        setFormData(defaultUploadFileScreenFormValues);
        setSelectedFile(null);
    };

    const createFileHandler = async () => {
        if (validateForm()) {
            setLoading(true);
            let password = await Storage.getValue("password");

            const newFormData = new FormData();
            newFormData.append("user_id", user?.username!);
            newFormData.append("document", selectedFile!);
            newFormData.append("name", formData.file_title);
            newFormData.append("password", password as string);
            const passportId = await Storage.getValue("passportId");

            try {
                const session = await getSession();
                if (!session) throw new Error("Session not available");

                const token = session.accessToken;

                const response = await API.createPassportFile(newFormData, token);
                await generatePassportFile({
                    folder: formData.file_folder,
                    title: formData.file_title,
                    url: response.link,
                    passportId: passportId,
                });

                resetFields();
                setMessage("File uploaded successfully");
                setLoading(false);
                setAlertVisibility(true);
            } catch (error: any) {
                setMessage(error.message);
                setLoading(false);
                setAlertVisibility(true);
            }
        }
    };

    const dismissKeyboard = () => {
        Keyboard.dismiss();
    };

    return (
      <PageContainer loading={loading}>
          <View style={uploadFileScreenStyles.viewContainer}>
              <Button
                title={"Select File"}
                onPress={selectFileHandler}
                variant={ButtonType.secondary}
              />
              {errors.selected_file_name && (
                <Text style={uploadFileScreenStyles.error}>
                    {errors.selected_file_name}
                </Text>
              )}
              {!selectedFile && (
                <Text style={uploadFileScreenStyles.help_text}>
                    Please choose a document to upload from this location. Alternatively, you may share a photo directly
                    from your photo gallery.

                </Text>
              )}


              {Platform.OS === "web" ? (
                <View style={uploadFileScreenStyles.inputContainer}>
                      <CustomTextInput
                        name="selected_file_name"
                        title="Selected File"
                        placeholder="Selected File"
                        defaultValue={formData.selected_file_name}
                        editable={false}
                        fieldStyles={uploadFileScreenStyles.input}
                        multiline
                      />
                      {errors.selected_file_name && (
                        <Text style={uploadFileScreenStyles.error}>
                            {errors.selected_file_name}
                        </Text>
                      )}

                      <CustomTextInput
                        name="file_title"
                        title="Title"
                        placeholder="File Title"
                        value={formData.file_title}
                        onChangeText={onChangeTextField}
                        fieldStyles={uploadFileScreenStyles.input}
                        editable={true}
                        multiline={false}
                      />
                      {errors.file_title && (
                        <>
                            <Text style={uploadFileScreenStyles.error} returnKeyType="done">
                                {errors.file_title}
                            </Text>
                        </>
                      )}
                      {renderFileFoldersSelectOptions()}
                      {errors.file_folder && (
                        <Text style={uploadFileScreenStyles.error}>
                            {errors.file_folder}
                        </Text>
                      )}
                  </View>
              ) : (
                  <TouchableWithoutFeedback onPress={dismissKeyboard}>
                      <View style={uploadFileScreenStyles.inputContainer}>
                          <CustomTextInput
                            name="selected_file_name"
                            title="Selected File"
                            placeholder="Selected File"
                            defaultValue={formData.selected_file_name}
                            editable={false}
                            fieldStyles={uploadFileScreenStyles.input}
                            multiline
                          />
                          {errors.selected_file_name && (
                            <Text style={uploadFileScreenStyles.error}>
                                {errors.selected_file_name}
                            </Text>
                          )}

                          <CustomTextInput
                            name="file_title"
                            title="Title"
                            placeholder="File Title"
                            defaultValue={formData.file_title}
                            onChangeText={onChangeTextField}
                            fieldStyles={uploadFileScreenStyles.input}
                            editable={true}
                            multiline={false}
                          />
                          {errors.file_title && (
                            <>
                                <Text style={uploadFileScreenStyles.error} returnKeyType="done">
                                    {errors.file_title}
                                </Text>
                            </>
                          )}
                          {renderFileFoldersSelectOptions()}
                          {errors.file_folder && (
                            <Text style={uploadFileScreenStyles.error}>
                                {errors.file_folder}
                            </Text>
                          )}
                      </View>
                  </TouchableWithoutFeedback>
                )}

              <View style={uploadFileScreenStyles.buttonContainer}>
                  <Button
                    title={"Create"}
                    onPress={createFileHandler}
                    variant={ButtonType.secondary}
                  />
                  <Button title={"Cancel"} onPress={onClickCancelButton}/>
              </View>
              <CustomAlert
                cancelText="cancel"
                confirmText="OK"
                visible={isAlertVisible}
                showCancelButton={false}
                title=""
                message={Message}
                onCancel={() => {
                }}
                onConfirm={async () => {
                    setAlertVisibility(false);
                    onClickCancelButton();
                }}
              />
          </View>
      </PageContainer>
    );
};

export default UploadFileScreen;

const getShareScreenStyles = (theme: AppTheme) => {
    return StyleSheet.create({
        viewContainer: {
            flex: 1,
            backgroundColor: theme.BACKGROUND,
            paddingTop: 100,
            paddingHorizontal: 15,
            display: "flex",
            alignItems: "center",
        },
        inputContainer: {
            gap: 20,
            marginTop: 50,
            marginBottom: 50,
            maxWidth: "100%"
        },
        input: {
            backgroundColor: theme.BACKGROUND,
            borderBottomColor: "#ddd",
            borderBottomWidth: 1,
            paddingVertical: 5,
            paddingHorizontal: 0,
        },
        buttonContainer: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 10,
        },
        error: {
            color: "red",
            marginBottom: 10,
        },
        help_text: {
            fontWeight: "400",
            marginTop: 60,
        },
    });
};
